import { MultipleEtfMarketCatalystReaction } from './MultipleEtfMarketCatalystReaction';
import { MarketCatalystReactionProps } from './market-catalyst-reaction.types';
import { SingleEtfMarketCatalystReaction } from './SingleEtfMarketCatalystReaction';

export type { MarketCatalystReactionProps } from './market-catalyst-reaction.types';

export const MarketCatalystReaction = (props: MarketCatalystReactionProps) =>
  props.tags.length > 1 ? (
    <MultipleEtfMarketCatalystReaction {...props} />
  ) : (
    <SingleEtfMarketCatalystReaction {...props} />
  );
